function toColorObj(r, g, b, a) {
  return { r: (r || 255), g: (g || 255), b: (b || 255), a: (a || 1) };
}

function fixColorObj(color) {
  if (color == null)
    return toColorObj(255, 255, 255, 1);

  const fix = (c) => {
    if (c == null) {
      return 255;
    }
    else if (c < 0) {
      return 0;
    }
    else if (c > 255) {
      return 255;
    }
    return c;
  };

  const fixAlpha = (a) => {
    if (a == null) {
      return 1;
    }
    else if (a < 0) {
      return 0;
    }
    else if (a > 1) {
      return 1;
    }
    return a;
  }

  return {
    r: fix(color.r),
    g: fix(color.g),
    b: fix(color.b),
    a: fixAlpha(color.a)
  };
}

function getColorStyle(color) {
  return { backgroundColor: colorToString(color) };
}

function getGradientColorStyle(color) {
  return {
    backgroundColor: colorToString(color),
    backgroundImage: gradientTopToBottomToString(color, toColorObj(255, 255, 255, 1))
  };
}

function colorToString(color) {
  color = fixColorObj(color);
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
}

function gradientTopToBottomToString(colorFrom, colorTo) {
  return `linear-gradient(${colorToString(colorFrom)}, ${colorToString(colorTo)})`;
}




const Color = {
  defaults: {
    text: '#676a6c',
    link: '#699eef',
    app: '#5267a2',
    primary: '#1c7fc6',
    success: '#1fb182',
    info: '#69afc5',
    warning: '#f39c53',
    danger: '#e06969',
    secondary: '#8c60d2',
    default: '#dddddd',
    light: '#f8f9fa',
    white: '#ffffff',
    dark: '#343a40',
    black: '#000000',
    gray: '#adadad',
  },
  toColorObj,
  getColorStyle,
  getGradientColorStyle,
}

export default Color;